export enum UredjivanjeActionTypeEnum {
  Emisije = 'Emisije',
  Rezervacije = 'Rezervacije',
}



// WEBPACK FOOTER //
// ./src/app/enums/uredjivanje-action-type.enum.ts